import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Lazy load all page components for better performance
const LandingPage = React.lazy(() => import("./pages/LandingPage"));

const App: React.FC = () => {
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
